module.exports = __webpack_public_path__ + "static/media/art53.16c09f9b.jpg";